import React from 'react'
import '../../../App.css';
import {Link} from 'react-router-dom';

export default function Salesforce() {
    return(
        <>
            <Link to="/DigitalPortfolio/projects" className="nav-back">
                <div className='nav-back-text'>{"<"}Back</div>
            </Link>
            <h1 className='header'>SalesForce</h1>
        </>
    )
}